<template>
  <main class="articles resources__page-topic">
    <div class="resources__top-wrap">
      <RichRenderer :richTextData="cPage.fields.paragraphRich" />
    </div>
  </main>
</template>
<script>
import { usePageMeta } from '@/composables/usePageMeta'
import { useAppStore } from '@/stores/app'

export default {
  name: 'Newsletter',
  props: {
    cPage: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const appStore = useAppStore()
    const { setPageMeta } = usePageMeta()

    setPageMeta(props.cPage?.fields?.pageMeta)

    return {
      appStore,
    }
  },
  data() {
    return {}
  },
  mounted() {
    window.jQuery = (el) => {
      if (el && el === document.querySelector('[name="email"]')) {
        el.change = (fn) => {
          el.value = this.appStore.newsletterMail
          const wrapper = {
            target: el,
          }
          fn(wrapper)
        }
        return el
      }
    }
  },
  beforeUnmount() {
    delete window.jQuery
  },
}
</script>
